import React, { PureComponent } from 'react';
import ArrowCurved from '~/assets/images/icons/arrow-curved.svg';
import ArrowStraight from '~/assets/images/icons/arrow-left.svg';

class Swoopy extends PureComponent {
  render() {
    if (!this.props.isVisible) {
      return false;
    }

    const style = {
      left: this.props.position.x,
      top: this.props.position.y
    };

    return (
      <div style={style} className="chart__swoopy">
        <div className="chart__swoopy-label">
          <div>Grippewelle seit</div>
          <div>
            <strong>2. Januarwoche</strong>
          </div>
        </div>
        <img className="chart__swoopy-curved" src={ArrowCurved} />
        <img className="chart__swoopy-straight" src={ArrowStraight} />
      </div>
    );
  }
}

export default Swoopy;
